module.exports = __webpack_public_path__ + "static/media/hero-small.4127e37b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/dashboard/hero-small.jpg
// module id = 372
// module chunks = 0